// extracted by mini-css-extract-plugin
module.exports = {"cw_category__badge":"CategoryBadgeComponent_cw_category__badge__Nd8fN","category":"CategoryBadgeComponent_category__gULB0","count":"CategoryBadgeComponent_count__lDg6M"};